import React from 'react';
import PropTypes from 'prop-types';
import {connect, ErrorMessage, Field as FormikField} from "formik";
import {FormText} from "reactstrap";
import {FormGroup} from "reactstrap";
import {CustomCheckComponent, CustomInputComponent} from "./CustomInputs";

const Field = (props) => {
    const {type, formik, name} = props;
    const {errors, touched} = formik;
    const error = Boolean(errors[name] && touched[name]);
    const fieldError = error ? "form_error" : "";

    let fieldItem = (
        <FormikField
            {...props}
            error={Boolean(error)}
            as={CustomInputComponent}
        />
    )

    if (type === "checkbox"){
        fieldItem = (
            <FormikField
                {...props}
                error={Boolean(error)}
                as={CustomCheckComponent}
            />
        )
    }

    return (
        <FormGroup className={fieldError}>
            {fieldItem}
            <ErrorMessage
                name={name}
                render={error => <FormText>{error}</FormText>}
            />
        </FormGroup>
    );
};

Field.propTypes = {
    type: PropTypes.oneOf([
        "password",
        "email",
        "checkbox",
        "text",
    ]).isRequired,
    validate: PropTypes.func,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
}
Field.defaultProps = {
    className: "mb-3",
    name: "default_name",
    sx: null
}
export default connect(Field);